import { observable } from "mobx";
import _ from 'lodash';
import moment from 'moment';

 export default class ImportacaoEntradaDepotStore {
    @observable tudoPronto;
    @observable isEditar;
    agendId;
    dadosMotoristaPronto;
    dadosContainersPronto;
    dadosNotasPronto;

    @observable dadosAgendamento;
    @observable containersOptions;
    @observable dadosNotaFiscal;
    @observable listaContainersOptions;
    @observable containersSelecionados;
    @observable tipoConsultaAnterior;

    @observable notaFiscalNObrigatoria;
    @observable tranAduaneiro;

    @observable abaEntradaAtiva;

    @observable terminal;
    @observable tiposAgenda;
    @observable tipoAgendaAtivo;
    @observable tipoAgendaRetirada;
    tiposAgendaRetirada;
    @observable tipoAgendaEntrada;
    tiposAgendaEntrada;
    @observable tipoEntradaImportacaoDepot;
    tiposEntradaImportacaoDepot;
    @observable tipoAgendaDesistencia
    tiposAgendaDesistencia

    @observable mostraNfNaoObrigatoria;

    @observable padraoDeCodigoInvalido;

    // Geral
    @observable categoriasCnh;
    @observable transportadoras;
    @observable listaHoras;
    @observable listaDatas;
    @observable transportadorasNotaFiscal;

    // Bookings
    @observable operacoes;
    @observable erroBookingTerminal;
    //
    @observable documentosRetirada;
    @observable carregandoDocumentos;
    @observable dadoDocumentoSelecionado;
    @observable carregandoContaineres;
    @observable dadoContainerSelecionado;
    
   // Adicionar por modais
   @observable mostrarInserirNovo;
   @observable inserindoEmModal;
   @observable codigoNovo;
   @observable codigoBooking;
   posBookingNovoContainer;
   posNotaFiscalNovoContainer;

    @observable codigoNovoImportacao;
    @observable codigoContainerImportacao;
    containerNovoImportacao;


    @observable listaMensagens;

    @observable salvar;

    camposObrigatorios;
    camposValidados;
    @observable modalConfirmacaoCargaReefer;
    @observable modalFimAgendamento;
    @observable modalFimNotaFiscal;
    @observable resultadoFimAgendamento;
    @observable resultadoFimNotasFiscais;
    @observable corrigirNotasFiscais;
    camposObrigatoriosNotas;
    @observable validacaoNotaOffline;

    @observable validandoXML;
    @observable erroImportXML;
    @observable erroImportXMLMensagem;
    xmlFileData;
    @observable jsonFile;

    @observable  validado
    @observable  bloqueiaCamposMotoristaCat;
    @observable  bloqueiaCamposMotoristaNome;
    @observable  bloqueiaCamposMotoristaCpf;

    @observable terminal
    //A variável abaixo foi definida para que possa ser feita a busca do terminal com mais segurança, depois que foi pedida a não obrigatoriedade em SSA
    @observable terminalObrigatorios;
    @observable blurStatus;

    @observable listaBookingsAnterior;
    @observable recarregarBooking;
    @observable containersEdicao;

    @observable exibeAlertaBookingNotas;
    @observable alertaBookingNotas;
    @observable listaNotasAssociadas;
    @observable loadNotasAssociadas;
     @observable msg;
    @observable alertaSSA;

    isDepot;

    constructor() {
        this.tudoPronto = false;
        this.agendId = false;
        this.carregandoDocumentos = false;
        this.dadoDocumentoSelecionado = false;
        this.carregandoContaineres = {};
        this.dadoContainerSelecionado = false;
        this.tipoConsultaAnterior = "";
        this.dadosNotaFiscal = { listaNf: [] };
        this.containersOptions = [];
        this.listaContainersOptions = [];
        this.containersSelecionados = [];
        this.dadosAgendamento = {};
        this.terminal = false;
        this.tiposAgenda = [];
        this.msg = "";
        this.isDepot = false;

        this.padraoDeCodigoInvalido = false;


        // Bookings
        this.operacoes = [];
        this.erroBookingTerminal = false;

        this.atualiza = false;
        this.atualizaData = true;
        this.atualizaBookings = false;
        this.atualizaRetiradas = false;
        this.atualizaDevolucoes = false;
        this.atualizaLacres = true;
        this.atualizaNotasFiscais = false;
        this.atualizaNotasFiscaisContainer = false;
        this.atualizaNotas = true;

        this.mostrarInserirNovo = "";
        this.inserindoEmModal = false;
        this.codigoNovo = "";
        this.codigoBooking = "";

        this.listaMensagens = false;

        this.notaFiscalNObrigatoria = false;
        this.tranAduaneiro = false;

        this.salvar = false;
        this.modalConfirmacaoCargaReefer = false;
        this.modalFimAgendamento = false;
        this.modalFimNotaFiscal = false;
        this.resultadoFimAgendamento = false;
        this.resultadoFimNotasFiscais = false;
        this.corrigirNotasFiscais = false;
        this.validacaoNotaOffline = true;

        this.bookingBlur = false;
        this.containerBlur = false;
        this.blurStatus = false;

        this.novoContainer = "";
        this.novoContainerImportacao = "";
        this.novoContainerIndex = 1;

        this.tipoAgendaAnterior = {};
        this.listaBookingsAnterior = {};
        this.recarregarBooking = false;

        this.containersEdicao = [];

        this.exibeAlertaBookingNotas = null;
        this.alertaBookingNotas = [];
        this.listaNotasAssociadas = [];
        this.loadNotasAssociadas = false;

        this.bloqueiaCamposMotoristaCat = true;
        this.bloqueiaCamposMotoristaNome = true;
        this.bloqueiaCamposMotoristaCpf = true;

        this.novoAgendamento = {};

        this.cdCntrReefer = [];
    };

    abrirInserirNovoBooking = () => {
        this.carregarCamposPorNovoBookingOpcional();
    };

    carregarCamposPorNovoBookingOpcional = () => {
        var novoBooking = {};
        this.codigoNovo = undefined;
        this.codigoBooking = this.codigoNovo;
        this.erroBookingTerminal = false;

        novoBooking = {
            NumBooking: this.codigoNovo,
            containerAtivo: -1,
            containers: [],
            VesselvisitId: "",
            IdViagemDtPrev: "",
            CdTipoCntr: "",
            ArmId: "",
            ApelidoArmador: "",
            CdPorto: "",
            NomePorto: "",
            LcCdLoc: "",
            bookingExistente: false,
            collapsed: false,
            dtRecebimento: ""
        }

        this.dadosMercadoria = {};
        //this.collapseBookings(true);

        this.inserirDadosBooking(novoBooking);

    };

    removerBookingContainer = (posBooking, index) => {
        let ctrnAtivo = (index === 0) ? 0 : index - 1;

        this.dadosAgendamento.listaBookings[posBooking].containers.splice(index, 1);
        this.setDadosAgendamentoSemPensar(`listaBookings[${posBooking}].containerAtivo`, ctrnAtivo);
    };

    setDadosAgendamentoSemPensar = (campo, valor) => {
        _.set(this.dadosAgendamento, campo, valor);

    };

    inserirDadosBooking = (novoBooking) => {
        if (_.has(this.dadosAgendamento, 'listaBookings')) {
            this.dadosAgendamento.listaBookings.push(novoBooking);
        } else {
            this.atualizaBookings = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento, `listaBookings`, lista);
            this.dadosAgendamento.listaBookings.push(novoBooking);
            this.atualizaBookings = true;
        }
    };

    verificaCamposComEspaco = (campo) => {
        if(this.dadosAgendamentoAceitaEspaco.includes(campo)) {
            return true;
        } else {
            if(this.dadosAgendamentoAceitaEspaco.find(c => campo.includes(c)) !== undefined) {
                return true;
            }
        }
        return false;
    }

    // Containers de Booking
    abrirInserirNovoContainerFilho = (posContainer) => {
        this.posNovoContainerFilho = posContainer;
        this.carregarCamposPorContainerOpcional(posContainer);
    };


    carregarCamposPorContainerOpcional = (posContainer) => {
        let valid = { CodCntr: "", armador: "", importador: "" }

        this.codigoNovo = this.novoContainer;

        var novoContainer = {
            CodCntr: this.codigoNovo,
            valid,
            armador: null,
            importador: null,
            isEscondido: false,
            PreviaImportacaoDepot: null
        }

        this.inserirDadosContainer(novoContainer);
    };



    setDadosAgendamento = (campo, event) => {
        let valorCampo = null;
        //if(event && event.target && typeof event.target.value === "string" && !this.verificaCamposComEspaco(campo) && event.target.value.includes(" ")) {
            //valorCampo = event.target.value.replace(/\s/g,"");
        //}

        //valorCampo = event.target.value;
        try{
            if (event) {
                if (event.target) {
                    if (event.target.value != "") {
                        if(!valorCampo) 
                            _.set(this.dadosAgendamento, campo, event.target.value);
                        else 
                            _.set(this.dadosAgendamento, campo, valorCampo);
                    }
                    else this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
                } else {
                    _.set(this.dadosAgendamento, campo, event.value);
                }
            } else {
                this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
            }
        }catch (ex){
            console.log(ex);
        }
        
    };

    inserirDadosContainer = (novoContainer) => {
        if (_.has(this.dadosAgendamento.listaBookings[this.posNovoContainerFilho], 'containers')) {
            this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containers.push(novoContainer);
        } else {
            let lista = new observable([]);
            _.set(this.dadosAgendamento.listaBookings[this.posNovoContainerFilho], `containers`, lista);
            this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containers.push(novoContainer);
        }
        this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containerAtivo = this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containers.length - 1;

        this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containers.map((i, index) =>{
            if(index != this.dadosAgendamento.listaBookings[this.posNovoContainerFilho].containerAtivo){
                i.isEscondido = true;
            }
        })

        this.setContainersOptions();
        this.fecharModais();
    };

    setContainersOptions = () => { 

        this.containersOptions = [];
    };


    fecharModais = () => {
        this.mostrarInserirNovo = "";
        this.codigoNovo = "";
        this.codigoBooking = "";
        this.listaMensagens = false;
        this.inserindoEmModal = false;
        this.modalFimAgendamento = false;
        this.modalConfirmacaoCargaReefer = false;
        this.salvar = false;
    };


}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/stores/ImportacaoEntradaDepotStore.js